import React, { useState } from "react";
import SmBannerImage from "../../images/pod-main-banner-route.svg";
import { Link } from "gatsby";
import HeaderAnim from "../common/utils/animations/textRevealAnimation";
import InView from "react-intersection-observer";
import LazyLoad from 'react-lazyload';

export default function MainBanner() {
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div className="cs-page-main-banner-section section-gap pod-cs-main-banner">
            <div className="cs-banner-image d-flex align-end justify-center">
                <div className="container d-flex flex-wrap align-start justify-center">
                    <LazyLoad>
                        <img src={SmBannerImage} title="last-mile-automation" alt="last-mile-automation" />
                    </LazyLoad>
                </div>
            </div>
            <div className="cs-main-banner-detail">
                <div className="container">
                    <div className="row d-flex flex-wrap row-banner-title">
                        <div className="col left-bar">
                            <h1>{isVisible ? <HeaderAnim header="Reinventing last mile delivery" /> : ""}</h1>
                        </div>
                        <div className="col right-bar">
                            <h3>How we helped a manufacturing giant to optimize and automate last mile delivery & customer experiences?</h3>
                        </div>
                    </div>
                    <InView onChange={(inView) => setIsVisible(inView)} triggerOnce={true}>
                        <div className="row d-flex flex-wrap align-v-center">
                            <div className="col left-bar">
                                <p>TRANSFORMATION · DESIGN · ENGINEERING · ANALYTICS</p>
                            </div>
                            <div className="col right-bar">
                                {/*<Link className="button button-xsmall button-white-border" to="/contact/">Let's Chat</Link>*/}
                            </div>
                        </div>
                    </InView>
                </div>
            </div>
        </div>
    );
}